var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_c(_vm.inputComponent,_vm._b({tag:"component",attrs:{"label":_vm.label,"value":_vm.value,"options":_vm.options,"disabled":_vm.disabled,"readonly":_vm.readonly},on:{"input":_vm.onInput}},'component',_vm.params,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }